import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  ChatBubbleLeftRightIcon,
  BuildingOffice2Icon,
  InboxIcon,
  ChartBarIcon,
  HeartIcon,
  UserGroupIcon,
} from '@heroicons/react/24/outline';

export default function QuickActions() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const actions = [
    {
      label: t('dashboard.quickChat', { defaultValue: 'ทดสอบแชท' }),
      icon: ChatBubbleLeftRightIcon,
      to: '/chat-test',
      color: 'bg-primary',
      iconColor: 'text-primary',
    },
    {
      label: t('dashboard.quickOrgs', { defaultValue: 'องค์กร' }),
      icon: BuildingOffice2Icon,
      to: '/organizations',
      color: 'bg-emerald-500',
      iconColor: 'text-emerald-600',
    },
    {
      label: t('dashboard.quickAgents', { defaultValue: 'เอเจนต์' }),
      icon: UserGroupIcon,
      to: '/agent-management',
      color: 'bg-sky-500',
      iconColor: 'text-sky-500',
    },
    {
      label: t('dashboard.quickTasks', { defaultValue: 'งาน' }),
      icon: InboxIcon,
      to: '/tasks',
      color: 'bg-violet-500',
      iconColor: 'text-violet-500',
    },
    {
      label: t('dashboard.quickUsage', { defaultValue: 'การใช้งาน' }),
      icon: ChartBarIcon,
      to: '/usage',
      color: 'bg-indigo-500',
      iconColor: 'text-indigo-500',
    },
    {
      label: t('dashboard.quickStatus', { defaultValue: 'สถานะระบบ' }),
      icon: HeartIcon,
      to: '/status',
      color: 'bg-semantic-up',
      iconColor: 'text-semantic-up',
    },
  ];

  return (
    <div className="rounded-2xl border border-app-border/80 bg-app-surface p-5 shadow-sm sm:p-6">
      <h3 className="mb-4 text-base font-semibold text-ink">
        {t('dashboard.quickActions', { defaultValue: 'ทางลัด' })}
      </h3>
      <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-3">
        {actions.map((a) => (
          <button
            key={a.to}
            type="button"
            onClick={() => navigate(a.to)}
            aria-label={a.label}
            className="flex flex-col items-center gap-2 rounded-xl border border-app-border/60 bg-app-bg/40 p-3 transition-colors hover:bg-app-muted/40"
          >
            <span className={`rounded-lg ${a.color}/15 p-2`}>
              <a.icon className={`h-5 w-5 ${a.iconColor}`} />
            </span>
            <span className="text-center text-xs font-medium text-app-text-sec">{a.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
